import {
  parseISO,
  differenceInSeconds,
  differenceInMinutes,
  differenceInHours,
  differenceInDays,
  format,
  isValid,
} from 'date-fns';

/**
 * The date under the author's own review, which reads `Posted on 02/11/2024` on both platforms.
 * Always absolute: the owner card states when the review was posted rather than how long ago,
 * and an unparseable date yields an empty string so the caller can drop the line entirely.
 */
export const formatReviewPostedOn = (dateString: string): string => {
  const date = parseISO(dateString);
  return isValid(date) ? format(date, 'dd/MM/yyyy') : '';
};

export const formatRelativeTime = (dateString: string): string => {
  const date = parseISO(dateString);
  const now = new Date();

  const diffInSeconds = differenceInSeconds(now, date);
  const diffInMinutes = differenceInMinutes(now, date);
  const diffInHours = differenceInHours(now, date);
  const diffInDays = differenceInDays(now, date);

  if (diffInSeconds < 60) {
    return `${diffInSeconds} seconds ago`;
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes} ${diffInMinutes === 1 ? 'min' : 'mins'} ago`;
  } else if (diffInHours < 24) {
    return `${diffInHours} ${diffInHours === 1 ? 'hour' : 'hours'} ago`;
  } else if (diffInDays < 30) {
    return `${diffInDays} ${diffInDays === 1 ? 'day' : 'days'} ago`;
  } else {
    return format(date, 'dd/MM/yyyy');
  }
};
